module.exports = __webpack_public_path__ + "img/closeModal.6c279ffb.png";